import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TooltipModule],
  templateUrl: './app.component.html',
  standalone: true
})
export class AppComponent {
  title = 'bmw-dienstleister-hub';
}
